module.exports = __webpack_public_path__ + "img/Dantam Hair 13.9138dad9.jpg";